"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePlaylist = exports.readPlaylistForUser = exports.readPlaylist = exports.readCurrentUser = exports.put = exports.post = exports.get = void 0;

var _limiter = require("../../../util/limiter");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var buildFormData = function buildFormData(params) {
  //Check if we have already had params as FormData then do nothing
  if (params instanceof FormData) return params;
  var formData = new FormData();

  for (var key in params) {
    var val = params[key];
    formData.append(key, val);
  } //console.log('formdata', formData)


  return formData;
};

var makeRequest = function makeRequest(url, method, data, _ref) {
  var cors = _ref.cors,
      contentType = _ref.contentType,
      credentials = _ref.credentials;
  //console.log('make request', url, method, data, cors, contentType, credentials)
  var body = null;
  var headers = {
    Accept: "*/*"
  };

  if (data && method !== "GET") {
    if (contentType === "application/json") {
      headers["Content-Type"] = contentType;
      body = JSON.stringify(data);
    } else if (contentType === "form") {
      body = buildFormData(data);
    }
  }

  var params = {
    method: method,
    mode: "cors",
    headers: headers,
    body: body
  };

  if (cors) {
    params["mode"] = "cors";
  }

  if (credentials) {
    params["credentials"] = "include";
  } //console.log("makeRequest", url, params)


  return (0, _limiter.limiter)(_objectSpread({
    url: url
  }, params), function (success, failure) {
    return new Promise(function (resolve, reject) {
      fetch(url, params).then(function (response) {
        return response.json();
      }).then(function (json) {
        if (json.success) {
          success();
          resolve(json.data || json.result);
        } else {
          var error = "Something went wrong";

          if (json && json.error) {
            error = json.error.message;
          }

          failure();
          reject(error);
        }
      }).catch(function (err) {
        failure();
        reject(err);
      });
    });
  });
};

var REQ_OPTS = {
  credentials: false,
  contentType: "application/json",
  cors: true
};

var get = function get(url, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var opts = Object.assign({}, REQ_OPTS, options);
  return makeRequest(url, "GET", params, opts);
};

exports.get = get;

var put = function put(url, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var opts = Object.assign({}, REQ_OPTS, options);
  return makeRequest(url, "PUT", data, opts);
};

exports.put = put;

var post = function post(url, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var opts = Object.assign({}, REQ_OPTS, options);
  return makeRequest(url, "POST", data, opts);
};
/** Users **/


exports.post = post;

var readCurrentUser = function readCurrentUser() {
  var url = "".concat(process.env.REACT_APP_WEB_API, "/webapp/users/self");
  return get(url, {});
};
/** Playlists **/


exports.readCurrentUser = readCurrentUser;

var readPlaylist = function readPlaylist(playlistId) {
  var url = "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/tracebot/playlists?playlist_key=").concat(playlistId);
  return get(url);
};

exports.readPlaylist = readPlaylist;

var updatePlaylist = function updatePlaylist(playlist) {
  var url = "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/tracebot/playlists?playlist_key=").concat(playlist.hash_key);
  return put(url, playlist);
};

exports.updatePlaylist = updatePlaylist;

var readPlaylistForUser = function readPlaylistForUser(userId) {
  var url = "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/tracebot/playlists?user_id=").concat(userId);
  return post(url, {
    name: "User Playlist",
    type: "normal",
    description: "Checkout my playlist"
  });
};

exports.readPlaylistForUser = readPlaylistForUser;